/* Meuse — beweging en onderdelen van de winkel.
   Eén script voor alle mu-secties. Eigen code, naar het gedrag van het model
   (smooche.com): rustig binnenkomen bij scrollen, een hero die overvloeit met
   een pauzeknop, een getekende cirkel om één woord, de aankondigingsbalk die
   wisselt, de galerij met duimen, de bundelkeuze met cadeaus die openspringen,
   de koopknop met de winkelwagen-la, de aftelbalk, zacht openende vragen en de
   koopbalk op de telefoon.

   Wie minder beweging wil (prefers-reduced-motion), krijgt alles meteen en
   stil te zien. Zonder JavaScript is alles ook zichtbaar: de verborgen
   beginstand hangt aan html.mu-motion, en die klasse zet alleen dit script
   (en een klein script in de head, met een vangnet van 4 s). */
(function () {
  'use strict';
  if (window.__meuse) { window.__meuse.scan(document); return; }

  var d = document, w = window, root = d.documentElement;
  var mq = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false, addEventListener: function () {} };
  var stil = function () { return mq.matches; };
  var clamp = function (v, a, b) { return v < a ? a : v > b ? b : v; };
  var each = function (lijst, fn) { Array.prototype.forEach.call(lijst || [], fn); };
  var num = function (el, naam, standaard) { var v = parseFloat(el.getAttribute(naam)); return isNaN(v) ? standaard : v; };
  var geld = function (centen) {
    var f = (w.Shopify && w.Shopify.currency && w.Shopify.currency.active) || 'EUR';
    // Zoals de winkel het schrijft (Liquid | money_without_trailing_zeros): €24,95 en €36, zonder spatie.
    try { return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: f }).format(centen / 100).replace(/\s/g, '').replace(/,00$/, ''); }
    catch (e) { return '€' + (centen / 100).toFixed(2).replace('.', ',').replace(/,00$/, ''); }
  };

  /* ═══ 0. VELDEN VRIJ ═══════════════════════════════════════════════════
     Met "disable_inspect" aan houdt het thema selectstart op document overal
     tegen, dus ook in velden: Ctrl+A en selecteren met de muis werkten daar
     niet (Senne, 8 okt, in het e-mailveld van de krasactie). In de vangfase
     op window gaat selectstart in een veld niet verder naar document; de
     beveiliging op de rest van de pagina blijft. */
  w.addEventListener('selectstart', function (e) {
    var t = e.target;
    if (t && t.nodeType === 3) t = t.parentNode;
    if (t && t.closest && t.closest('input, textarea, select, [contenteditable]:not([contenteditable="false"])')) e.stopPropagation();
  }, true);

  /* ═══ 1. BINNENKOMEN ═══════════════════════════════════════════════════
     [data-mu-reveal="up|fade|scale|left|right|draw"] en [data-mu-delay="ms"].
     Het element krijgt .is-in als 12% ervan in beeld is, of als het al boven
     het scherm ligt (snel scrollen). "draw" tekent een SVG-lijn (de cirkel). */
  var revIO = null;
  function laatZien(el) {
    if (el.__muIn) return;
    el.__muIn = true;
    if (revIO) revIO.unobserve(el);
    var ms = stil() ? 0 : num(el, 'data-mu-delay', 0);
    if (ms) el.style.transitionDelay = ms + 'ms';
    el.classList.add('is-in');
    setTimeout(function () { el.classList.add('is-done'); if (ms) el.style.transitionDelay = ''; }, ms + 1300);
  }
  function bijBinnenkomen(entries) {
    each(entries, function (e) {
      if (e.isIntersecting && e.intersectionRatio >= 0.12) laatZien(e.target);
      else if (!e.isIntersecting && e.boundingClientRect.bottom < 0) laatZien(e.target);
      else if (e.isIntersecting && e.boundingClientRect.height * 0.12 > w.innerHeight) laatZien(e.target);
    });
  }

  /* ═══ 2. OPTELLEN ════════════════════════════════════════════════════════
     [data-mu-count="3"] of "1 min" of "4,8": telt op van nul als het in beeld
     komt (1,4 s, easeOutQuart). Wat al in beeld staat bij het laden, telt
     niet: dat zou knipperen. */
  var telIO = null;
  var TEL = /^(\D{0,3}?)(\d+)([.,]\d+)?(\D{0,12})$/;
  function telOp(el) {
    var ruw = el.getAttribute('data-mu-count') || el.textContent;
    var m = TEL.exec(String(ruw).trim());
    if (!m) return;
    var voor = m[1] || '', na = m[4] || '', sep = m[3] ? m[3][0] : '', dec = m[3] ? m[3].length - 1 : 0;
    var doel = parseFloat(m[2] + (m[3] ? '.' + m[3].slice(1) : ''));
    if (!(doel > 0)) { el.textContent = ruw; return; }
    var start = null, duur = 1400;
    var stap = function (ts) {
      if (start === null) start = ts;
      var t = Math.min(1, (ts - start) / duur), e = 1 - Math.pow(1 - t, 4);
      var v = (doel * e).toFixed(dec);
      el.textContent = voor + (sep ? v.replace('.', sep) : v) + na;
      if (t < 1) requestAnimationFrame(stap); else el.textContent = ruw;
    };
    setTimeout(function () { requestAnimationFrame(stap); }, num(el, 'data-mu-delay', 0) + 100);
  }

  /* ═══ 3. DE HEADER EN DE LA ═════════════════════════════════════════════
     [data-mu-header]: .is-scrolled na 10 px (schaduw). De la (telefoonmenu)
     komt van links; Escape of een klik buiten sluit hem, de focus gaat terug. */
  function header(hdr) {
    if (hdr.__mu) return; hdr.__mu = true;
    var la = d.getElementById(hdr.getAttribute('data-mu-la'));
    var knoppen = d.querySelectorAll('[data-mu-la-knop="' + (la ? la.id : '') + '"]');
    var scroll = function () { hdr.classList.toggle('is-scrolled', w.scrollY > 10); };
    w.addEventListener('scroll', scroll, { passive: true });
    scroll();
    if (!la) return;
    var oudeOverflow = '', terugNaar = null;
    la.inert = true;
    var open = function () { return la.classList.contains('is-open'); };
    var wissel = function (zet) {
      var nu = typeof zet === 'boolean' ? zet : !open();
      if (nu === open()) return;
      la.classList.toggle('is-open', nu);
      la.setAttribute('aria-hidden', nu ? 'false' : 'true');
      la.inert = !nu;
      each(knoppen, function (k) { k.setAttribute('aria-expanded', nu ? 'true' : 'false'); });
      var houder = la;
      while (houder.parentElement && houder.parentElement !== d.body) houder = houder.parentElement;
      if (nu) {
        each(d.body.children, function (k) { if (k !== houder && !k.inert && k.tagName !== 'SCRIPT') { k.inert = true; k.__muInert = true; } });
        // Ook de header zelf (logo, knoppen): Tab blijft in de la.
        hdr.inert = true;
        oudeOverflow = d.body.style.overflow; d.body.style.overflow = 'hidden';
        terugNaar = d.activeElement;
        var eerste = la.querySelector('.mu-la__links a') || la.querySelector('a, button:not([tabindex="-1"])');
        if (eerste) setTimeout(function () { if (open()) eerste.focus({ preventScroll: true }); }, 60);
      } else {
        each(d.body.children, function (k) { if (k.__muInert) { k.inert = false; k.__muInert = false; } });
        hdr.inert = false;
        d.body.style.overflow = oudeOverflow;
        if (terugNaar && terugNaar.isConnected) terugNaar.focus({ preventScroll: true });
      }
    };
    each(knoppen, function (k) { k.addEventListener('click', function () { wissel(); }); });
    each(la.querySelectorAll('[data-mu-la-dicht]'), function (k) { k.addEventListener('click', function () { wissel(false); }); });
    each(la.querySelectorAll('a'), function (a) { a.addEventListener('click', function () { wissel(false); }); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && open()) wissel(false); });
  }

  /* ═══ 4. WISSELENDE BERICHTEN (aankondigingsbalk) ═══════════════════════
     [data-mu-ticker="5000"]: de kinderen wisselen om de zoveel ms, met een
     zachte overgang. Stil bij aanwijzen, focus of een verborgen tabblad. */
  function ticker(el) {
    if (el.__mu) return; el.__mu = true;
    var lijst = el.querySelectorAll('[data-mu-tick]');
    if (lijst.length < 2) return;
    var i = 0, pauze = false;
    each(lijst, function (t, j) { t.classList.toggle('is-current', j === 0); t.setAttribute('aria-hidden', j === 0 ? 'false' : 'true'); });
    el.addEventListener('mouseenter', function () { pauze = true; });
    el.addEventListener('mouseleave', function () { pauze = false; });
    var t = setInterval(function () {
      if (pauze || d.hidden || el.contains(d.activeElement) || stil()) return;
      lijst[i].classList.remove('is-current'); lijst[i].setAttribute('aria-hidden', 'true');
      i = (i + 1) % lijst.length;
      lijst[i].classList.add('is-current'); lijst[i].setAttribute('aria-hidden', 'false');
    }, num(el, 'data-mu-ticker', 5000));
    el.__muStop = function () { clearInterval(t); };
  }

  /* ═══ 5. DE HERO DIE OVERVLOEIT ═════════════════════════════════════════
     [data-mu-slides="6000"] met [data-mu-slide]-kinderen en een
     [data-mu-pauze]-knop. Verborgen dia's zijn inert. Stopt bij een verborgen
     tabblad en bij minder beweging. */
  function slides(el) {
    if (el.__mu) return; el.__mu = true;
    var lijst = el.querySelectorAll('[data-mu-slide]');
    var knop = el.querySelector('[data-mu-pauze]');
    if (lijst.length < 2) { if (knop) knop.hidden = true; return; }
    var i = 0, gepauzeerd = false, timer = 0, ms = num(el, 'data-mu-slides', 6000);
    var toon = function (n) {
      lijst[i].classList.remove('is-current'); lijst[i].setAttribute('aria-hidden', 'true'); lijst[i].inert = true;
      i = (n + lijst.length) % lijst.length;
      lijst[i].classList.add('is-current'); lijst[i].removeAttribute('aria-hidden'); lijst[i].inert = false;
    };
    each(lijst, function (s, j) { s.classList.toggle('is-current', j === 0); s.inert = j !== 0; if (j) s.setAttribute('aria-hidden', 'true'); });
    var stop = function () { clearInterval(timer); timer = 0; };
    var start = function () {
      stop();
      if (gepauzeerd || stil() || d.hidden) return;
      timer = setInterval(function () { if (!el.contains(d.activeElement)) toon(i + 1); }, ms);
    };
    if (knop) {
      knop.hidden = false;
      knop.addEventListener('click', function () {
        gepauzeerd = !gepauzeerd;
        knop.setAttribute('aria-pressed', gepauzeerd ? 'true' : 'false');
        knop.setAttribute('aria-label', gepauzeerd ? knop.getAttribute('data-speel') : knop.getAttribute('data-pauzeer'));
        knop.classList.toggle('is-paused', gepauzeerd);
        start();
      });
    }
    d.addEventListener('visibilitychange', start);
    el.__muStop = stop;
    start();
  }

  /* ═══ 6. CARROUSELS EN DE GALERIJ ═══════════════════════════════════════
     [data-mu-carousel] met een [data-mu-track] (scroll-snap), knoppen
     [data-mu-prev]/[data-mu-next], stippen [data-mu-dots] en duimen
     [data-mu-thumb="i"]. Het kind dat het dichtst bij de linkerrand staat,
     krijgt .is-current. */
  function carrousel(c) {
    if (c.__mu) return; c.__mu = true;
    var track = c.querySelector('[data-mu-track]');
    if (!track) return;
    var kids = function () { return Array.prototype.filter.call(track.children, function (k) { return k.offsetParent !== null; }); };
    var dots = c.querySelector('[data-mu-dots]');
    var duimen = c.querySelectorAll('[data-mu-thumb]');
    var huidig = -1;
    var padding = function () { var n = parseFloat(getComputedStyle(track).scrollPaddingLeft); return isFinite(n) ? n : 0; };
    var tekenDots = function () {
      if (!dots) return;
      var n = kids().length;
      if (dots.children.length === n) return;
      dots.innerHTML = '';
      for (var i = 0; i < n; i++) {
        var b = d.createElement('button');
        b.type = 'button'; b.className = 'mu-dot'; b.setAttribute('aria-label', 'Ga naar ' + (i + 1));
        (function (j) { b.addEventListener('click', function () { naar(j); }); })(i);
        dots.appendChild(b);
      }
    };
    var index = function () {
      var lijst = kids(), tr = track.getBoundingClientRect(), ref = tr.left + padding();
      var best = 0, afstand = Infinity;
      lijst.forEach(function (k, i) {
        var a = Math.abs(k.getBoundingClientRect().left - ref);
        if (a < afstand) { afstand = a; best = i; }
      });
      return best;
    };
    var naar = function (i, gedrag) {
      var lijst = kids(); if (!lijst.length) return;
      i = clamp(i, 0, lijst.length - 1);
      var tr = track.getBoundingClientRect(), r = lijst[i].getBoundingClientRect();
      track.scrollTo({ left: track.scrollLeft + r.left - tr.left - padding(), behavior: gedrag || (stil() ? 'auto' : 'smooth') });
    };
    var bij = function () {
      var i = index(), lijst = kids();
      var prev = c.querySelector('[data-mu-prev]'), next = c.querySelector('[data-mu-next]');
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      if (i === huidig) return;
      huidig = i;
      lijst.forEach(function (k, j) { k.classList.toggle('is-current', j === i); });
      if (dots) each(dots.children, function (b, j) { b.classList.toggle('is-active', j === i); b.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      each(duimen, function (t) {
        var aan = parseInt(t.getAttribute('data-mu-thumb'), 10) === i;
        t.classList.toggle('is-active', aan); t.setAttribute('aria-current', aan ? 'true' : 'false');
      });
      // De actieve duim blijft in beeld: de rij scrolt mee (Senne, 8 okt). Alleen de rij, niet de
      // pagina, dus geen scrollIntoView.
      var actief = c.querySelector('[data-mu-thumb="' + i + '"]'), rij = actief && actief.parentElement;
      if (rij && rij.scrollWidth > rij.clientWidth + 1) {
        var rr = rij.getBoundingClientRect(), ar = actief.getBoundingClientRect();
        rij.scrollTo({ left: Math.max(0, rij.scrollLeft + ar.left - rr.left - (rr.width - ar.width) / 2), behavior: stil() ? 'auto' : 'smooth' });
      }
    };
    var t = 0;
    track.addEventListener('scroll', function () { cancelAnimationFrame(t); t = requestAnimationFrame(bij); }, { passive: true });
    each(c.querySelectorAll('[data-mu-prev]'), function (b) { b.addEventListener('click', function () { naar((huidig < 0 ? index() : huidig) - 1); }); });
    each(c.querySelectorAll('[data-mu-next]'), function (b) { b.addEventListener('click', function () { naar((huidig < 0 ? index() : huidig) + 1); }); });
    each(duimen, function (b) { b.addEventListener('click', function (e) { e.preventDefault(); naar(parseInt(b.getAttribute('data-mu-thumb'), 10)); }); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); naar(huidig + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); naar(huidig - 1); }
    });
    c.__muNaar = naar;
    tekenDots();
    w.addEventListener('resize', function () { tekenDots(); huidig = -1; bij(); }, { passive: true });
    bij();
  }

  /* ═══ 7. DE AFTELBALK ════════════════════════════════════════════════════
     [data-mu-countdown="7"]: loopt elke 7 uur rond (zoals het model). Met
     [data-mu-tot="middernacht"] telt hij af tot 00:00 in de tijd van de
     bezoeker en begint dan weer bij 23:59:59 (Senne, 8 okt: "Het moet om
     midnight eindigen"). De balk [data-mu-bar] loopt leeg met de tijd die
     van de ronde over is. Met [data-mu-pct] (het percentage verkocht uit de
     editor) staat de balk vast op dat percentage en loopt alleen de tijd. */
  function klok(el) {
    if (el.__mu) return; el.__mu = true;
    var uren = num(el, 'data-mu-countdown', 7), tijd = el.querySelector('[data-mu-time]');
    var tot = el.getAttribute('data-mu-tot');
    var balk = el.hasAttribute('data-mu-pct') ? null : el.querySelector('[data-mu-bar]');
    var tik = function () {
      var ronde, rest;
      if (tot === 'middernacht') {
        var nu = new Date(), morgen = new Date(nu.getFullYear(), nu.getMonth(), nu.getDate() + 1);
        ronde = morgen - new Date(nu.getFullYear(), nu.getMonth(), nu.getDate());
        rest = morgen - nu;
      } else {
        ronde = uren * 3600000; rest = ronde - (Date.now() % ronde);
      }
      var s = Math.floor(rest / 1000), h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      if (tijd) tijd.textContent = [h, m, sec].map(function (x) { return String(x).padStart(2, '0'); }).join(':');
      if (balk) balk.style.width = Math.max(4, (rest / ronde) * 100).toFixed(2) + '%';
    };
    tik(); var t = setInterval(tik, 1000);
    el.__muStop = function () { clearInterval(t); };
  }

  /* ═══ 15. WAT ZIT ERIN (mu-inhoud) ════════════════════════════════════════
     Naar de ingrediëntenrij van Smooche: een stip per plek waar de rij kan
     stoppen (bij vijf kaarten en vier in beeld zijn dat er twee), pijlen die
     een kaart verder schuiven, en de stippen en pijlen alleen als de rij echt
     schuift (data-schuift). */
  function inhoud(rij) {
    if (rij.__mu) return; rij.__mu = true;
    var track = rij.querySelector('[data-mu-inhoud-track]');
    var dots = rij.querySelector('[data-mu-inhoud-dots]');
    var vorige = rij.querySelector('[data-mu-inhoud-prev]'), volgende = rij.querySelector('[data-mu-inhoud-next]');
    if (!track) return;
    var kaarten = Array.prototype.slice.call(track.children);
    var plekken = [];
    var huidig = function () {
      var x = track.scrollLeft, best = 0;
      plekken.forEach(function (p, i) { if (Math.abs(p - x) < Math.abs(plekken[best] - x)) best = i; });
      return best;
    };
    var bij = function () {
      if (!plekken.length) return;
      var i = huidig();
      if (dots) each(dots.children, function (b, j) { b.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      if (vorige) vorige.disabled = track.scrollLeft <= 2;
      if (volgende) volgende.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    };
    var bouw = function () {
      var max = Math.max(0, track.scrollWidth - track.clientWidth);
      var start = kaarten.length ? kaarten[0].offsetLeft : 0;
      plekken = kaarten.map(function (k) { return Math.min(k.offsetLeft - start, max); })
        .filter(function (p, i, lijst) { return i === 0 || p - lijst[i - 1] > 2; });
      rij.toggleAttribute('data-schuift', max > 2);
      if (dots) {
        dots.innerHTML = '';
        plekken.forEach(function (p, i) {
          var b = d.createElement('button');
          b.type = 'button'; b.className = 'mu-inhoud__dot'; b.setAttribute('aria-label', 'Toon ingrediënt ' + (i + 1));
          b.addEventListener('click', function () { track.scrollTo({ left: p, behavior: stil() ? 'auto' : 'smooth' }); });
          dots.appendChild(b);
        });
      }
      bij();
    };
    var schuif = function (r) {
      var i = clamp(huidig() + r, 0, plekken.length - 1);
      track.scrollTo({ left: plekken[i] || 0, behavior: stil() ? 'auto' : 'smooth' });
    };
    if (vorige) vorige.addEventListener('click', function () { schuif(-1); });
    if (volgende) volgende.addEventListener('click', function () { schuif(1); });
    var raf = 0;
    track.addEventListener('scroll', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; bij(); }); }, { passive: true });
    if (w.ResizeObserver) new ResizeObserver(bouw).observe(track); else w.addEventListener('resize', bouw);
    bouw();
  }

  /* ═══ 8. DE PRODUCTVORM ══════════════════════════════════════════════════
     Varianten kiezen (als die er zijn), de bundel kiezen (zet het aantal en
     opent de cadeaus die daarbij horen), prijzen bijwerken, en toevoegen via
     /cart/add.js met de la van het thema (cart-drawer.renderContents). Lukt
     de la niet, dan naar /cart: een klant blijft nooit hangen. */
  function productvorm(f) {
    if (f.__mu) return; f.__mu = true;
    var dataEl = f.querySelector('script[data-mu-product]');
    var product = null;
    try { product = dataEl ? JSON.parse(dataEl.textContent) : null; } catch (e) { product = null; }
    var idVeld = f.querySelector('input[name="id"]');
    var aantalVeld = f.querySelector('input[type="hidden"][name="quantity"]');
    var knop = f.querySelector('[data-mu-atc]');
    var sectie = f.closest('[data-mu-product-section]') || d;
    var bezig = false;
    var huidigeVariant = product ? (product.variants.find(function (v) { return idVeld && String(v.id) === idVeld.value; }) || product.variants[0]) : null;
    var naarCart = function () { w.location.assign((w.routes && w.routes.cart_url) || '/cart'); };

    var kies = function () {
      if (!product) return null;
      var gekozen = [];
      each(f.querySelectorAll('[data-mu-option]'), function (groep) {
        var aan = groep.querySelector('input:checked');
        gekozen[parseInt(groep.getAttribute('data-mu-option'), 10)] = aan ? aan.value : null;
      });
      return product.variants.find(function (v) { return v.options.every(function (o, i) { return gekozen[i] == null || gekozen[i] === o; }); }) || null;
    };
    var bundel = function () { return f.querySelector('[data-mu-bundle] input:checked'); };
    var cadeauAanbod = function (pid) {
      var el = d.getElementById('cg-gift-config');
      if (!el || !pid) return [];
      var cfg = null;
      try { cfg = JSON.parse(el.textContent); } catch (e) { return []; }
      var nu = Date.now();
      return ((cfg && cfg.offers) || []).filter(function (o) {
        if (!o || !o.qualifying || !o.gift || !o.gift.variant_id || o.gift.available === false) return false;
        if (String(o.qualifying.product_id) !== String(pid)) return false;
        if (o.gedrag && o.gedrag.auto_add === false) return false;
        var sc = o.schedule || {};
        if (sc.enabled && ((sc.start_at && Date.parse(sc.start_at) > nu) || (sc.end_at && Date.parse(sc.end_at) < nu))) return false;
        return true;
      });
    };
    var aantal = function () { var b = bundel(); return b ? parseInt(b.getAttribute('data-qty'), 10) || 1 : 1; };

    /* De bundelkaarten rekenen met de prijs van de gekozen variant: met de
       korting in procenten (blokken), of met een vast bedrag eraf
       (data-korting, in centen). Zo rekent ook de korting in Shopify: "vanaf
       N stuks zoveel euro eraf" (Codex, 6 oktober 2026). */
    var bundelPrijzen = function (v) {
      if (!v) return;
      each(f.querySelectorAll('[data-mu-bundle] input'), function (inp) {
        if (inp.hasAttribute('data-variant')) return;
        var q = parseInt(inp.getAttribute('data-qty'), 10) || 1;
        var pct = parseFloat(inp.getAttribute('data-pct')) || 0;
        var kaart = inp.closest('label');
        var basis = v.price * q;
        var prijs = Math.round(basis * (1 - pct / 100));
        if (inp.hasAttribute('data-korting')) prijs = Math.max(0, basis - (parseInt(inp.getAttribute('data-korting'), 10) || 0));
        var was = Math.max(basis, (v.compare_at_price || 0) * q);
        var p = kaart.querySelector('[data-mu-bprice]'), s = kaart.querySelector('[data-mu-bcompare]'), e = kaart.querySelector('[data-mu-beach]'), b = kaart.querySelector('[data-mu-bsave]');
        if (p) p.textContent = geld(prijs);
        if (s) { s.hidden = !(was > prijs); s.textContent = geld(was); }
        if (e) e.textContent = geld(Math.round(prijs / q));
        if (b) { b.hidden = !(was > prijs); b.textContent = 'Bespaar ' + geld(was - prijs); }
      });
    };
    var cadeaus = function () {
      var q = aantal();
      each(sectie.querySelectorAll('[data-mu-gift]'), function (t) {
        var open = q >= (parseInt(t.getAttribute('data-min'), 10) || 1);
        t.classList.toggle('is-open', open);
        t.setAttribute('aria-label', (t.getAttribute('data-naam') || '') + (open ? ': ontgrendeld' : ': nog op slot'));
      });
    };
    var toon = function (v) {
      huidigeVariant = v;
      if (!v) { if (knop) { knop.disabled = true; knop.querySelector('[data-mu-atc-label]').textContent = knop.getAttribute('data-unavailable'); } return; }
      if (idVeld) idVeld.value = v.id;
      each(sectie.querySelectorAll('[data-mu-price]'), function (el) { el.textContent = geld(v.price); });
      each(sectie.querySelectorAll('[data-mu-compare]'), function (el) {
        el.hidden = !(v.compare_at_price > v.price); if (!el.hidden) el.textContent = geld(v.compare_at_price);
      });
      each(sectie.querySelectorAll('[data-mu-option-value]'), function (el) {
        var i = parseInt(el.getAttribute('data-mu-option-value'), 10); el.textContent = v.options[i] || '';
      });
      bundelPrijzen(v);
      if (knop) {
        knop.disabled = !v.available;
        knop.querySelector('[data-mu-atc-label]').textContent = v.available ? knop.getAttribute('data-add') : knop.getAttribute('data-soldout');
      }
      if (v.featured_media) {
        var gal = sectie.querySelector('[data-mu-gallery]');
        var dia = gal && gal.querySelector('[data-media-id="' + v.featured_media.id + '"]');
        if (dia && gal.__muNaar) gal.__muNaar(Array.prototype.indexOf.call(dia.parentNode.children, dia));
      }
      var url = new URL(w.location.href); url.searchParams.set('variant', v.id);
      w.history.replaceState(w.history.state, '', url.toString());
      d.dispatchEvent(new CustomEvent('mu:variant', { detail: { variant: v } }));
    };
    each(f.querySelectorAll('[data-mu-option] input'), function (inp) {
      inp.addEventListener('change', function () {
        var groep = inp.closest('[data-mu-option]');
        each(groep.querySelectorAll('.is-active'), function (x) { x.classList.remove('is-active'); });
        if (inp.closest('label')) inp.closest('label').classList.add('is-active');
        toon(kies());
      });
    });
    each(f.querySelectorAll('[data-mu-bundle] input'), function (inp) {
      inp.addEventListener('change', function () {
        each(f.querySelectorAll('[data-mu-bundle] label'), function (l) { l.classList.toggle('is-active', l.contains(inp)); });
        if (aantalVeld) aantalVeld.value = aantal();
        cadeaus();
        d.dispatchEvent(new CustomEvent('mu:bundle', { detail: { qty: aantal() } }));
      });
    });
    /* ?bundel=2 in de link (vanaf de bundelkaarten op de home) kiest die bundel. */
    var gevraagd = parseInt(new URL(w.location.href).searchParams.get('bundel'), 10);
    if (gevraagd > 0) {
      var doel = f.querySelector('[data-mu-bundle] input[data-qty="' + gevraagd + '"]');
      if (doel && !doel.checked) { doel.checked = true; doel.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    if (aantalVeld) aantalVeld.value = aantal();
    cadeaus();
    // De prijzen uit Liquid kloppen al; opnieuw rekenen hoeft pas bij een andere variant.
    if (product && product.variants.length > 1) bundelPrijzen(huidigeVariant);
    w.addEventListener('pageshow', function () {
      if (product && product.variants.length > 1) toon(kies());
      if (aantalVeld) aantalVeld.value = aantal();
      cadeaus();
    });

    f.addEventListener('submit', function (e) {
      e.preventDefault();
      if (bezig || !knop || knop.disabled) return;
      bezig = true;
      knop.classList.add('is-busy'); knop.setAttribute('aria-busy', 'true');
      var la = d.querySelector('cart-drawer');
      if (la && typeof la.setActiveElement === 'function') { try { la.setActiveElement(d.activeElement); } catch (err) { /* */ } }
      var secties = la && typeof la.getSectionsToRender === 'function'
        ? la.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-drawer', 'cart-icon-bubble'];
      var route = new URL((w.routes && w.routes.cart_add_url) || '/cart/add', w.location.origin);
      if (!/\.js$/.test(route.pathname)) route.pathname += '.js';
      var q = aantal();
      /* Een vaste bundel (eigen product) gaat er één keer in; anders q keer dit product. */
      var keuze = bundel();
      var vastId = keuze && keuze.getAttribute('data-variant');
      var hoofd = vastId
        ? { id: parseInt(vastId, 10), quantity: 1, pid: keuze.getAttribute('data-product') }
        : { id: parseInt(idVeld.value, 10), quantity: q, pid: product && product.id };
      var aanbod = cadeauAanbod(hoofd.pid);
      /* Zonder cadeaus: het formulier zoals het is. Met cadeaus bij dit product: eerst de wagen
         lezen (wat er al in ligt telt mee, en een cadeau dat er al is komt er niet nog eens bij),
         dan alles in één keer, zodat de la de cadeaus meteen laat zien. */
      var verzoek = !aanbod.length ? Promise.resolve(null) : fetch(((w.routes && w.routes.cart_url) || '/cart') + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      verzoek.then(function (wagen) {
        var opties;
        if (!vastId && (!aanbod.length || !wagen)) {
          var body = new FormData(f);
          body.set('quantity', String(q));
          body.append('sections', secties.join(','));
          body.append('sections_url', w.location.pathname);
          opties = { method: 'POST', body: body, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
        } else {
          /* Shopify zet nieuwe regels bovenaan: eerst de cadeaus, dan het product, zodat het
             product in de la boven zijn cadeaus staat. */
          var items = [];
          if (!wagen) aanbod = [];
          aanbod.forEach(function (o) {
            var al = 0, cadeauAl = false;
            (wagen.items || []).forEach(function (it) {
              if (it.properties && it.properties._cg_gift === o.id) { cadeauAl = true; return; }
              var telt = String(it.product_id) === String(o.qualifying.product_id)
                && (!(o.qualifying.variant_ids || []).length || o.qualifying.variant_ids.map(String).indexOf(String(it.variant_id)) >= 0);
              if (telt) al += it.quantity;
            });
            var telt = !(o.qualifying.variant_ids || []).length || o.qualifying.variant_ids.map(String).indexOf(String(hoofd.id)) >= 0;
            if (!cadeauAl && al + (telt ? hoofd.quantity : 0) >= (parseInt(o.qualifying.min_qty, 10) || 1)) {
              items.push({ id: parseInt(o.gift.variant_id, 10), quantity: parseInt(o.gift.qty, 10) || 1, properties: { _cg_gift: o.id } });
            }
          });
          items.push({ id: hoofd.id, quantity: hoofd.quantity });
          opties = { method: 'POST', body: JSON.stringify({ items: items, sections: secties.join(','), sections_url: w.location.pathname }), headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
        }
        return fetch(route.href, opties);
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) { var fout = new Error(res.j && (res.j.description || res.j.message) || 'Toevoegen lukte niet'); fout.http = true; throw fout; }
          d.dispatchEvent(new CustomEvent('mu:added', { detail: res.j }));
          /* Toegevoegd is toegevoegd: tekent de la niet, dan naar /cart, nooit een
             foutmelding (dan zou iemand nog eens klikken en er twee hebben). */
          try {
            var geldig = la && typeof la.renderContents === 'function' && res.j.sections
              && secties.every(function (id) { return typeof res.j.sections[id] === 'string'; });
            if (!geldig) { naarCart(); return; }
            la.classList.remove('is-empty');
            la.renderContents(res.j);
          } catch (renderFout) { naarCart(); }
        })
        .catch(function (err) {
          /* Geen antwoord (netwerk weg): misschien is hij toch toegevoegd. Dan
             niet opnieuw laten klikken, maar de wagen laten zien zoals hij is. */
          if (!err.http) { naarCart(); return; }
          var fout = f.querySelector('[data-mu-error]');
          if (fout) { fout.textContent = err.message; fout.hidden = false; setTimeout(function () { fout.hidden = true; }, 6000); }
        })
        .finally(function () { bezig = false; knop.classList.remove('is-busy'); knop.removeAttribute('aria-busy'); });
    });
  }

  /* ═══ 9. DE KOOPBALK (telefoon) ══════════════════════════════════════════
     Verschijnt als de echte koopknop boven uit beeld is, en wijkt voor de
     footer. Een klik verstuurt de echte vorm, met de gekozen bundel. */
  function koopbalk(balk) {
    if (balk.__mu) return; balk.__mu = true;
    var doel = d.querySelector('[data-mu-atc]');
    var voet = d.querySelector('.mu-voet, footer');
    var boven = false, voetZicht = false;
    balk.inert = true;
    var zet = function () {
      var aan = boven && !voetZicht;
      balk.classList.toggle('is-shown', aan);
      balk.setAttribute('aria-hidden', aan ? 'false' : 'true');
      balk.inert = !aan;
    };
    /* Meten bij het scrollen (één keer per frame): een IntersectionObserver
       meldt niets als je in één sprong over de koopknop heen gaat, en dan
       bleef de balk weg (Seoul Roots, 6 oktober 2026). */
    var raf = 0;
    var meet = function () {
      raf = 0;
      if (doel) boven = doel.getBoundingClientRect().bottom < 0;
      if (voet) voetZicht = voet.getBoundingClientRect().top < w.innerHeight;
      zet();
    };
    var plan = function () { if (!raf) raf = requestAnimationFrame(meet); };
    w.addEventListener('scroll', plan, { passive: true });
    w.addEventListener('resize', plan, { passive: true });
    meet();
    each(balk.querySelectorAll('[data-mu-balk-knop]'), function (k) {
      k.addEventListener('click', function () {
        var f = d.querySelector('form[data-mu-form]');
        if (!f) { w.location.href = (w.routes && w.routes.cart_url) || '/cart'; return; }
        if (f.requestSubmit) f.requestSubmit(); else f.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    });
    var bijwerken = function () {
      var f = d.querySelector('form[data-mu-form]');
      var b = f && f.querySelector('[data-mu-bundle] input:checked');
      var kaart = b && b.closest('label');
      var naam = kaart && kaart.querySelector('[data-mu-bname]'), prijs = kaart && kaart.querySelector('[data-mu-bprice]');
      each(balk.querySelectorAll('[data-mu-balk-naam]'), function (el) { if (naam) el.textContent = naam.textContent; });
      each(balk.querySelectorAll('[data-mu-balk-prijs]'), function (el) { if (prijs) el.textContent = prijs.textContent; });
    };
    d.addEventListener('mu:bundle', bijwerken);
    d.addEventListener('mu:variant', function () { setTimeout(bijwerken, 0); });
    bijwerken();
  }

  /* ═══ 10. VRAGEN: zacht open en dicht ═══════════════════════════════════ */
  function vraag(det) {
    if (det.__mu) return; det.__mu = true;
    var sum = det.querySelector('summary'), body = det.querySelector('[data-mu-answer]');
    if (!sum || !body) return;
    var anim = null, gewenst = det.open, versie = 0;
    sum.addEventListener('click', function (e) {
      if (stil() || !body.animate) return;
      e.preventDefault();
      if (!anim) gewenst = det.open;
      gewenst = !gewenst;
      var token = ++versie;
      var van = det.open ? body.getBoundingClientRect().height : 0;
      if (anim) anim.cancel();
      det.open = true;
      var naar = gewenst ? body.scrollHeight : 0;
      det.classList.toggle('is-closing', !gewenst);
      anim = body.animate([{ height: van + 'px', opacity: gewenst ? 0.3 : 1 }, { height: naar + 'px', opacity: gewenst ? 1 : 0 }], { duration: gewenst ? 340 : 260, easing: 'cubic-bezier(.2,.7,.2,1)' });
      anim.onfinish = function () {
        if (token !== versie) return;
        det.open = gewenst; det.classList.remove('is-closing'); anim = null;
      };
    });
  }

  /* ═══ 11. DE GETEKENDE CIRKEL ════════════════════════════════════════════
     .mu-cirkel: om het cursieve woord in de kop komt een lijn die met de
     hand getekend lijkt (een lus die net niet sluit, zoals bij het model).
     De CSS tekent hem als de kop binnenkomt (stroke-dashoffset). */
  var NS = 'http://www.w3.org/2000/svg';
  function cirkel(kop) {
    each(kop.querySelectorAll('em'), function (em) {
      if (em.querySelector('.mu-cirkel__lijn')) return;
      var svg = d.createElementNS(NS, 'svg');
      svg.setAttribute('class', 'mu-cirkel__lijn');
      svg.setAttribute('viewBox', '0 0 200 60');
      svg.setAttribute('preserveAspectRatio', 'none');
      svg.setAttribute('aria-hidden', 'true');
      var pad = d.createElementNS(NS, 'path');
      pad.setAttribute('d', 'M112 7C64 3 12 11 7 30c-4 17 44 25 96 23 54-2 93-12 90-29-3-14-44-21-90-19-29 1-55 6-71 13');
      pad.setAttribute('pathLength', '1');
      svg.appendChild(pad);
      em.appendChild(svg);
    });
  }

  /* ═══ 11b. DIEPTE BIJ HET SCROLLEN ══════════════════════════════════════
     [data-mu-parallax]: het beeld erin schuift een paar pixels tegen het
     scrollen in (--mu-py van -1 tot 1, de CSS zet het om). Eén meting per
     frame, alleen voor wat in de buurt van het scherm is. */
  var diepte = [], diepteRaf = 0;
  function diepteMeet() {
    diepteRaf = 0;
    var h = w.innerHeight;
    diepte.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > h + 200) return;
      var p = (r.top + r.height / 2 - h / 2) / (h / 2 + r.height / 2);
      el.style.setProperty('--mu-py', clamp(p, -1, 1).toFixed(3));
    });
  }
  function diepteVraag() { if (!diepteRaf) diepteRaf = w.requestAnimationFrame(diepteMeet); }
  function parallax(el) {
    if (el.__muP || stil()) return; el.__muP = true;
    if (!diepte.length) {
      w.addEventListener('scroll', diepteVraag, { passive: true });
      w.addEventListener('resize', diepteVraag);
    }
    diepte.push(el);
    diepteVraag();
  }

  /* ═══ 12. DE WINKELWAGEN ════════════════════════════════════════════════
     De la is die van het thema (snippets/cart-drawer.liquid). Hier alleen:
     - [data-mu-wagen-add="<variant>"] met data-qty: het product in de lege
       wagen en het duwtje naar de volgende bundel. Via /cart/add.js en de
       la van het thema (renderContents), net als de koopknop; lukt het
       tekenen niet, dan naar /cart.
     - is-opening op de la als die opengaat, zodat de regels één voor één
       binnenkomen (CSS), en niet bij elke klik op plus of min. */
  function wagen() {
    if (d.__muWagen) return; d.__muWagen = true;
    var naarCart = function () { w.location.assign((w.routes && w.routes.cart_url) || '/cart'); };
    var plop = function () {
      setTimeout(function () {
        var n = d.querySelector('cart-drawer .mu-wagen__n');
        if (n) { n.classList.remove('is-plop'); void n.offsetWidth; n.classList.add('is-plop'); }
      }, 60);
    };
    d.addEventListener('mu:added', plop);
    d.addEventListener('click', function (e) {
      var knop = e.target && e.target.closest ? e.target.closest('[data-mu-wagen-add]') : null;
      if (!knop || knop.classList.contains('is-busy')) return;
      e.preventDefault();
      var la = d.querySelector('cart-drawer');
      var secties = la && typeof la.getSectionsToRender === 'function'
        ? la.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-drawer', 'cart-icon-bubble'];
      knop.classList.add('is-busy'); knop.setAttribute('aria-busy', 'true');
      var route = new URL((w.routes && w.routes.cart_add_url) || '/cart/add', w.location.origin);
      if (!/\.js$/.test(route.pathname)) route.pathname += '.js';
      fetch(route.href, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          items: [{ id: parseInt(knop.getAttribute('data-mu-wagen-add'), 10), quantity: parseInt(knop.getAttribute('data-qty'), 10) || 1 }],
          sections: secties.join(','),
          sections_url: w.location.pathname
        })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.j && (res.j.description || res.j.message)) || 'Toevoegen lukte niet');
          d.dispatchEvent(new CustomEvent('mu:added', { detail: res.j }));
          var geldig = la && typeof la.renderContents === 'function' && res.j.sections
            && secties.every(function (id) { return typeof res.j.sections[id] === 'string'; });
          if (!geldig) { naarCart(); return; }
          la.classList.remove('is-empty');
          la.renderContents(res.j);
        })
        .catch(function () { naarCart(); })
        .finally(function () { knop.classList.remove('is-busy'); knop.removeAttribute('aria-busy'); });
    });
    var la = d.querySelector('cart-drawer');
    if (!la || !('MutationObserver' in w)) return;

    /* De verzendbescherming is een keuze van de klant. Ligt alleen die nog in
       de wagen (de snippet zet dan data-mu-bescherming-weg met het
       regelnummer), dan halen we hem weg: zonder product valt er niets te
       beschermen. */
    var opruimen = false;
    var beschermingWeg = function () {
      var m = la.querySelector('[data-mu-bescherming-weg]');
      if (!m || opruimen) return;
      opruimen = true;
      var secties = typeof la.getSectionsToRender === 'function'
        ? la.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-drawer', 'cart-icon-bubble'];
      var route = new URL((w.routes && w.routes.cart_change_url) || '/cart/change', w.location.origin);
      if (!/\.js$/.test(route.pathname)) route.pathname += '.js';
      fetch(route.href, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ line: parseInt(m.getAttribute('data-mu-bescherming-weg'), 10), quantity: 0, sections: secties.join(','), sections_url: w.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (!j || !j.sections || typeof la.renderContents !== 'function') return;
          la.classList.toggle('is-empty', j.item_count === 0);
          la.renderContents(j);
        })
        .catch(function () { /* de wagen werkt ook zonder */ })
        .finally(function () { opruimen = false; });
    };
    beschermingWeg();
    new MutationObserver(beschermingWeg).observe(la, { childList: true, subtree: true });

    /* Het akkoordvinkje blijft aan. Het thema tekent de la opnieuw bij elke
       plus, min of toevoeging, en dan stond het vinkje weer uit en de
       afrekenknop weer grijs. Wie het één keer aanzette, houdt het aan (ook op
       de volgende pagina, zolang de sessie loopt); uitzetten blijft gewoon kunnen. */
    var SLEUTEL = 'mu-akkoord', akkoord = false;
    try { akkoord = w.sessionStorage.getItem(SLEUTEL) === '1'; } catch (e) { akkoord = false; }
    var zetAkkoord = function (aan) { akkoord = aan; try { w.sessionStorage.setItem(SLEUTEL, aan ? '1' : '0'); } catch (e) { /* */ } };
    var herstel = function (vak) {
      if (!akkoord || !vak || vak.getAttribute('data-checked') === 'true') return;
      setTimeout(function () {
        if (vak.getAttribute('data-checked') === 'true') return;
        vak.__muAuto = true; vak.click(); vak.__muAuto = false;
      }, 0);
    };
    d.addEventListener('click', function (e) {
      var vak = e.target && e.target.closest ? e.target.closest('cart-drawer tnc-chekcbox') : null;
      if (!vak || vak.__muAuto) return;
      setTimeout(function () { zetAkkoord(vak.getAttribute('data-checked') === 'true'); }, 0);
    }, true);
    if (w.customElements && w.customElements.whenDefined) {
      w.customElements.whenDefined('tnc-chekcbox').then(function () { herstel(la.querySelector('tnc-chekcbox')); });
    }
    new MutationObserver(function (lijst) {
      if (!akkoord) return;
      lijst.forEach(function (m) {
        each(m.addedNodes, function (n) {
          if (n.nodeType !== 1) return;
          herstel(n.matches('tnc-chekcbox') ? n : n.querySelector('tnc-chekcbox'));
        });
      });
    }).observe(la, { childList: true, subtree: true });

    var open = la.classList.contains('active'), t = 0;
    new MutationObserver(function () {
      var nu = la.classList.contains('active');
      if (nu && !open) {
        la.classList.add('is-opening');
        clearTimeout(t);
        t = setTimeout(function () { la.classList.remove('is-opening'); }, 1100);
      }
      open = nu;
    }).observe(la, { attributes: true, attributeFilter: ['class'] });
  }

  /* ═══ OPZETTEN ═══════════════════════════════════════════════════════════ */
  var aan = false;
  function scan(bereik) {
    bereik = bereik || d;
    each(bereik.querySelectorAll('.mu-cirkel'), cirkel);
    each(bereik.querySelectorAll('[data-mu-reveal]'), function (el) {
      if (el.__muR) return; el.__muR = true;
      if (!aan) { laatZien(el); return; }
      revIO.observe(el);
    });
    each(bereik.querySelectorAll('[data-mu-count]'), function (el) {
      if (el.__muC) return; el.__muC = true;
      /* In een rij die opzij schuift (telefoon) telt de rij als geheel: anders bleven de kaarten
         buiten beeld op 0% staan tot je veegde (Meuse, 9 okt 2026). */
      var rij = el.closest('[data-mu-track]');
      if (!aan || (rij || el).getBoundingClientRect().top < w.innerHeight) return;
      var ruw = el.getAttribute('data-mu-count');
      var m = TEL.exec(String(ruw).trim());
      if (!m || !(parseFloat(m[2]) > 0)) return;
      el.textContent = (m[1] || '') + '0' + (m[3] ? m[3][0] + m[3].slice(1).replace(/\d/g, '0') : '') + (m[4] || '');
      if (!rij) { telIO.observe(el); return; }
      (rij.__muTel = rij.__muTel || []).push(el);
      if (rij.__muTel.length === 1) telIO.observe(rij);
    });
    each(bereik.querySelectorAll('[data-mu-header]'), header);
    each(bereik.querySelectorAll('[data-mu-ticker]'), ticker);
    each(bereik.querySelectorAll('[data-mu-slides]'), slides);
    each(bereik.querySelectorAll('[data-mu-carousel]'), carrousel);
    each(bereik.querySelectorAll('[data-mu-inhoud]'), inhoud);
    each(bereik.querySelectorAll('[data-mu-countdown]'), klok);
    each(bereik.querySelectorAll('form[data-mu-form]'), productvorm);
    each(bereik.querySelectorAll('[data-mu-sticky-bar]'), koopbalk);
    each(bereik.querySelectorAll('details[data-mu-faq]'), vraag);
    if (aan) each(bereik.querySelectorAll('[data-mu-parallax]'), parallax);
  }

  function start() {
    if (aan) return;
    if (!('IntersectionObserver' in w) || stil()) { aan = false; root.classList.remove('mu-motion'); return; }
    aan = true;
    root.classList.add('mu-motion');
    revIO = new IntersectionObserver(bijBinnenkomen, { threshold: [0, 0.12] });
    telIO = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { telIO.unobserve(e.target); if (e.target.__muTel) e.target.__muTel.forEach(telOp); else telOp(e.target); } });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.2 });
  }

  start();
  w.__meuse = { scan: scan };
  if (mq.addEventListener) mq.addEventListener('change', function () {
    if (!stil()) return;
    root.classList.remove('mu-motion');
    each(d.querySelectorAll('[data-mu-reveal]'), laatZien);
  });
  d.addEventListener('shopify:section:unload', function (e) {
    var sec = e.target; if (!sec || !sec.querySelectorAll) return;
    [sec].concat(Array.prototype.slice.call(sec.querySelectorAll('*'))).forEach(function (el) {
      if (typeof el.__muStop === 'function') el.__muStop();
    });
  });
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { scan(d); wagen(); });
  else { scan(d); wagen(); }

  // De thema-editor: opnieuw binden na een wijziging, en laten zien wat je bewerkt.
  ['shopify:section:load', 'shopify:section:reorder'].forEach(function (n) {
    d.addEventListener(n, function (e) { setTimeout(function () { scan(e.target || d); }, 0); });
  });
  d.addEventListener('shopify:section:select', function (e) {
    each((e.target || d).querySelectorAll('[data-mu-reveal]'), laatZien);
  });
  // Toetsenbordfocus maakt verborgen inhoud meteen zichtbaar.
  d.addEventListener('focusin', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('[data-mu-reveal]:not(.is-in)') : null;
    if (el) laatZien(el);
  });
})();
